/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createUserRequest } from '../models/api_createUserRequest';
import type { api_createUserResponse } from '../models/api_createUserResponse';
import type { api_getUserResponse } from '../models/api_getUserResponse';
import type { api_resetUsersBulkRequest } from '../models/api_resetUsersBulkRequest';
import type { api_resetUsersBulkResponse } from '../models/api_resetUsersBulkResponse';
import type { api_updateUserRequestBody } from '../models/api_updateUserRequestBody';
import type { api_updateUserResponse } from '../models/api_updateUserResponse';
import type { api_updateUsersBulkRequest } from '../models/api_updateUsersBulkRequest';
import type { db_ListDropdownUsersRow } from '../models/db_ListDropdownUsersRow';
import type { db_ListUsersRow } from '../models/db_ListUsersRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Users {
    /**
     * Get a list of users
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListUsersRow OK
     * @throws ApiError
     */
    public static listUsers(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListUsersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a new user record
     * @param body User details
     * @returns api_createUserResponse OK
     * @throws ApiError
     */
    public static createUser(
        body: api_createUserRequest,
    ): CancelablePromise<api_createUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Reset user accounts (password, security questions, OTP) and send new registration emails
     * @param body User IDs to reset
     * @returns api_resetUsersBulkResponse OK
     * @throws ApiError
     */
    public static resetUsersBulk(
        body: api_resetUsersBulkRequest,
    ): CancelablePromise<api_resetUsersBulkResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/bulk-reset',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update users
     * @param body User data
     * @returns void
     * @throws ApiError
     */
    public static updateUsersBulk(
        body: api_updateUsersBulkRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users/bulk-update',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of users for a dropdown
     * @param userType User type
     * @param countryId Country ID
     * @param excludeCommitteeId Exclude committee ID
     * @param includeCommitteeId Include committee ID
     * @param programmeCode Programme code
     * @returns db_ListDropdownUsersRow OK
     * @throws ApiError
     */
    public static listDropdownUsers(
        userType: string,
        countryId?: number,
        excludeCommitteeId?: number,
        includeCommitteeId?: number,
        programmeCode?: string,
    ): CancelablePromise<Array<db_ListDropdownUsersRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/type/{user_type}',
            path: {
                'user_type': userType,
            },
            query: {
                'country_id': countryId,
                'exclude_committee_id': excludeCommitteeId,
                'include_committee_id': includeCommitteeId,
                'programme_code': programmeCode,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a user record
     * @param id User ID
     * @returns api_getUserResponse OK
     * @throws ApiError
     */
    public static getUser(
        id: number,
    ): CancelablePromise<api_getUserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a user record
     * @param id User ID
     * @param body User details
     * @returns api_updateUserResponse OK
     * @throws ApiError
     */
    public static updateUser(
        id: number,
        body: api_updateUserRequestBody,
    ): CancelablePromise<api_updateUserResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                500: `Internal Server Error`,
            },
        });
    }
}
